<div id="previous-billing-cycle-wrapper">
  <app-billing-cycle-display-card [billingCycle]="pastBillingCycle$ | async"></app-billing-cycle-display-card>
</div>
